import "./team.css";

export default function Team() {
  return (
    <section className="Team" id="team">
      <div>
        <h2>Notre équipe</h2>
        <h3>
          La Société Nice Plomberie, c'est avant tout, une équipe et des
          compétences.
        </h3>
        <p>
          Certains de nos collaborateurs travaillent dans notre
          <br /> société depuis plus de 30 ans.
        </p>
        <ul>
          <li>
            <p>
              <strong>1</strong>
              <br /> Gérant
            </p>
          </li>
          <li>
            <p>
              <strong>1</strong>
              <br /> Assistante de Direction
            </p>
          </li>
          <li>
            <p>
              <strong>1</strong>
              <br /> Standardiste
            </p>
          </li>
          <li>
            <p>
              <strong>5</strong>
              <br /> Techniciens Qualifiés et Diplômés
            </p>
          </li>
          <li>
            <p>
              <strong>2</strong>
              <br /> Apprentis
            </p>
          </li>
        </ul>
      </div>
      {/* <p>
        *Chaque employé de notre société <strong>NICE PLOMBERIE</strong>{" "}
        bénéficie d'une
        <br /> formation continue au sein même de notre société.
      </p> */}
    </section>
  );
}
